/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EC2Instance } from './eC2Instance';
import { UpgradeDeploymentStatusEnum } from './upgradeDeploymentStatusEnum';


export interface EC2InstancesInfo { 
    ec2_instances: Array<EC2Instance>;
    status: UpgradeDeploymentStatusEnum;
    total_instances: number;
}
export namespace EC2InstancesInfo {
}


